import axios from "axios";

export const state = {
  expiries: [],
};

export const getters = {
  expiries: (state) => state.expiries,
};

export const mutations = {
  SetExpiredProducts(state, newValue) {
    state.expiries = newValue;
  },
};

export const actions = {
  async fetchExpiredProducts({ commit }) {
    await axios.get("/expired-products").then((res) => {
      commit("SetExpiredProducts", res.data.expiries);
    });
  },
};
